<script>
export default {
  props: {
    value: { type: [Number, Boolean] },
    values: { type: Array },
    title: { type: String },
    name: { type: String },
    row: { type: Boolean },
    boldLabel: { type: Boolean },
    fillWidth: { type: Boolean }
  }
}
</script>
<template>
  <v-row justify="space-around">
    <v-col cols="12" :sm="!fillWidth && 6">
      <h4 class="font-weight-bold wordBreak" v-html="title" />
      <v-radio-group
        :value="value"
        :row="row"
        hide-details
        @change="$emit('input', $event)"
      >
        <div v-for="(radioValue, index) in values" :key="index">
          <v-hover v-slot="{ hover }">
            <v-radio
              :id="`${radioValue.label}-confirmation-radio`"
              :name="name"
              :class="{ 'font-weight-bold': boldLabel }"
              :label="radioValue.label"
              :value="radioValue.value"
            >
              <template #label>
                <div>
                  {{ radioValue.label }}
                  <v-tooltip
                    v-if="radioValue.text && fillWidth"
                    top
                    max-width="600"
                  >
                    <template #activator="{ on }">
                      <v-icon
                        color="primary"
                        class="information-icon"
                        :class="{ 'on-hover': hover }"
                        v-on="on"
                      >mdi-information</v-icon
                      >
                    </template>
                    <span v-html="radioValue.text" />
                  </v-tooltip>
                </div>
              </template>
            </v-radio>
          </v-hover>
          <v-row v-if="radioValue.text && !fillWidth" :class="{ 'mr-2': row }">
            <v-col class="ml-8 pt-0 text-body-2">
              <span class="secondary--text" v-html="radioValue.text" />
            </v-col>
          </v-row>
        </div>
      </v-radio-group>
    </v-col>
  </v-row>
</template>
